import { Component, OnInit } from '@angular/core';
import { ResidentServicesService } from '../../../services/resident-services.service';
import { AmenitiesService } from '../../../services/amenities.service';
import { ServiceRequestAction, ServiceRequestService } from '../../../services/service-request.service';
import { DocumentsService } from '../../../services/documents.service';
import { EmailService } from '../../../services/email.service';
import { PassOnLogService } from '../../../services/pass-on-log.service';
import { ParcelsService } from '../../../services/parcels.service';
import { IncidentReportsService } from '../../../services/incident-reports.service';
import { KeyLogService } from '../../../services/key-log.service';
import { OrderByPipe } from '../../../pipes/orderPipe/order-by.pipe';
import { ParkingPassService } from '../../../services/parking-pass.service';
import { DailyReportsService } from '../../../services/daily-reports.service';
import { PropertyService } from '../../admin/property/services/property.service';
import { ResidentService } from '../../../services/resident.service';
import { FrontDeskInstructionsService } from '../../../services/front-desk-instructions.service';
import { ApiClientService } from 'app/services/api-client.service';


@Component({
    selector: 'favorite-services',
    templateUrl: 'favorite-services.component.html',
    styleUrls: ['favorite-services.component.scss']
})

export class FavoriteServicesComponent implements OnInit {
    show = 4;

    constructor(
        public residentServicesService: ResidentServicesService,
        public amenitiesService: AmenitiesService,
        public serviceRequestService: ServiceRequestService,
        public documentsService: DocumentsService,
        public emailService: EmailService,
        public passOnLogService: PassOnLogService,
        public parcelsService: ParcelsService,
        public incidentReportsService: IncidentReportsService,
        public dailyReportsService: DailyReportsService,
        public keyLogService: KeyLogService,
        public orderBy: OrderByPipe,
        public parkingPassService: ParkingPassService,
        public propertyService: PropertyService,
        public frontDeskInstructionsService: FrontDeskInstructionsService,
        private residentService: ResidentService,
        public api: ApiClientService
    ) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.residentService.getWelcomeMessage();

        // The way to get Instructions

        // const url = `/v1/resident_instruction?user_id=${JSON.parse(localStorage.getItem('residentselectedBuilding')).residentBdId}`;
        // this.api.get('domainBD', url)
        //     .toPromise()
        //     .then(
        //         (res) => {
        //             let body = JSON.parse(res._body);
        //             console.log(body)
        //         },
        //         (msg) => {
        //             console.log(msg)
        //         }
        //     )
    }

    eventClick(item) {
        this.residentServicesService.dictionary[item.code].service[this.residentServicesService.dictionary[item.code].showmodal] = true;
    }

    moreServices() {
        if (this.show <= 4) {
            this.show = Number(this.residentServicesService.itemsOfServices.length);
        } else {
            this.show = 4;
        }
    }

    displayElement(el): boolean {
        let show = false;

        if(el.code != 'parking_pass' && el.code != 'amenity' && el.code != 'service_request')
            show = true;
        else if(el.code == 'parking_pass' && this.parkingPassService.residentParkinglots.length > 0)
            show = true;
        else if(el.code == 'amenity' && this.amenitiesService.amenitiesByBuilding.length > 0)
            show = true;
        else if(el.code == 'service_request' &&
                this.residentService.allowedForResident('service_request') &&
                this.serviceRequestService.residentAccessController(ServiceRequestAction.requestCreate))
            show = true;
        // else if(el.code === 'front_desk_instructions')
        //     show = true;

        return show;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/home/favorite-services/favorite-services.component.ts